import sortCinemas from '../../../functions/sortCinemas'
import FormAdData from '../../forms/FormAdData'
import Translation from '../../Translation/cont/Translation'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'

const EditAd = ({itemData, onUpdateItem, sortedMovieDataKeys, movieData, cliCinemas, clientCinemaId, closePagePath, suffixEdit, features, transNoMovieSelected}) => {
    if(!clientCinemaId) {
        return ''
    }

    const pageName = itemData && itemData.title ? itemData.title : <Translation id="content_default_title"/>
    const cliCinemasIdList = sortCinemas(clientCinemaId, cliCinemas)

    return (
        <WrapperPageSimple pageTitle={pageName} closePagePath={closePagePath}>
            <div className="program-page site-content">
                {itemData ? (
                    <FormAdData 
                        contentData={itemData} 
                        features={features} 
                        cliCinemas={cliCinemas} 
                        clientCinemaId={clientCinemaId} 
                        sortedMovieDataKeys={sortedMovieDataKeys} 
                        movieData={movieData} 
                        onUpdateAD={onUpdateItem}
                        closePagePath={closePagePath}
                        suffixEdit={suffixEdit}
                        cliCinemasIdList={cliCinemasIdList}
                        transNoMovieSelected={transNoMovieSelected}
                    />
                ):(
                    <div><Translation id="no_data"/></div>
                )}
            </div>
        </WrapperPageSimple>
    )
}

export default EditAd